export class Message {
  text: string;
  level: Level;

  constructor(text: string, level: Level) {
    this.text = text;
    this.level = level;
  }
}

export class Level {
  value: string

  constructor(value: string) {
    this.value = value;
  }
}
